import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Research">
                <h1>Research And Development Company</h1>
              </div>
              <p className="main_para">Leveraging technology to innovate</p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_content_txt">
              <p>
                TekRevol is a technology research and development company
                working to improve and enhance existing services or products. We
                also assist the launch of any new service or product offering
                backed by solid research into the final stage.
              </p>
              <ul>
                <li>Process Identification</li>
                <li>Ideation &amp; Prototyping</li>
                <li>Threat Mitigation</li>
                <li>Unconventional Approach</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
